import React from 'react';
import { FadeIn } from './FadeIn';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Kit de Plantillas Nutricionales Pro',
    desc: 'Plantillas editables para recomendaciones, seguimiento, hábitos, objetivos, educación alimentaria y entrega profesional al paciente.',
    price: '$12.000'
  }, {
    num: '02',
    title: 'Sistema de Evaluación Nutricional Pro',
    desc: 'Formatos listos para anamnesis, evaluación inicial, chequeo de evolución, indicadores clave y recopilación ordenada de datos clínicos.',
    price: '$15.000'
  }, {
    num: '03',
    title: 'Biblioteca Visual para Educación del Paciente',
    desc: 'Material visual práctico y fácil de entender para explicar porciones, hábitos, educación alimentaria y adherencia sin improvisar.',
    price: '$10.000'
  }, {
    num: '04',
    title: 'Sistema de Organización del Consultorio Pro',
    desc: 'Herramientas para ordenar agenda, seguimiento, archivos, procesos internos y flujo de atención de forma más simple y profesional.',
    price: '$11.000'
  }, {
    num: '05',
    title: 'Kit de Marketing y Captación para Nutricionistas',
    desc: 'Recursos para comunicar mejor lo que hacés, atraer pacientes, publicar con más claridad y vender tu servicio con confianza.',
    price: '$13.000'
  }, {
    num: '06',
    title: 'Guía de Precios, Cobro y Rentabilidad de la Consulta',
    desc: 'Guía práctica para definir precios, ordenar tus números, mejorar rentabilidad y cobrar con más seguridad y criterio profesional.',
    price: '$9.000'
  }];
  return <section className="pt-5 pb-8 px-3 bg-black" data-id="element-37">
      <div className="max-w-5xl mx-auto" data-id="element-38">
        <FadeIn className="text-center mb-6" data-id="element-39">
          <h2 className="font-display text-2xl md:text-4xl font-bold text-white mb-2" data-id="element-40">
            Más los 6 Bonos Estratégicos
          </h2>
          <p className="text-sm font-medium text-accent" data-id="element-41">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-42">
          {bonuses.map((bonus, idx) => <FadeIn key={idx} delay={idx * 0.1} className="bg-black border border-accent/25 rounded-lg p-4 flex flex-col h-full hover:border-accent/50 transition-colors relative overflow-hidden group" data-id="element-43">
              <div className="absolute top-0 right-0 w-20 h-20 bg-accent/5 rounded-bl-full -mr-6 -mt-6 transition-transform group-hover:scale-110" data-id="element-44" />

              <div className="flex items-center justify-between mb-3 relative z-10" data-id="element-45">
                <span className="text-xl font-black text-white/10 font-display" data-id="element-46">
                  {bonus.num}
                </span>
                <span className="bg-accent/10 text-accent text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider border border-accent/20" data-id="element-47">
                  Bono {parseInt(bonus.num)}
                </span>
              </div>

              <h3 className="text-sm font-bold text-white mb-1.5 relative z-10" data-id="element-48">
                {bonus.title}
              </h3>

              <p className="text-white/60 text-xs leading-relaxed mb-4 flex-1 relative z-10" data-id="element-49">
                {bonus.desc}
              </p>

              <div className="flex items-center justify-between pt-2 border-t border-white/10 relative z-10" data-id="element-50">
                <span className="text-white/40 line-through text-xs font-medium" data-id="element-51">
                  {bonus.price}
                </span>
                <span className="bg-accent text-black font-black text-xs px-2.5 py-0.5 rounded-full uppercase tracking-wide" data-id="element-52">
                  Gratis
                </span>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} className="text-center mt-5" data-id="element-53">
          <p className="text-white/50 italic max-w-2xl mx-auto text-xs" data-id="element-54">
            Todo esto viene incluido hoy para que empieces con más herramientas,
            más seguridad y más valor percibido en tu consulta clínica.
          </p>
        </FadeIn>
      </div>
    </section>;
}